//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../../../axios/axios.js'
import { EventBus } from '../../../../../EventBus/EventBus.js'

import ReportCheckListCableSegments from './ReportCheckListCableSegments.vue'

export default {
  name: 'ReportCheckListCable',
  components: {
    ReportCheckListCableSegments
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    workType: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default () {
        return ''
      }
    },
    resultName: {
      type: String,
      default: ''
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    },
    dispatcherInterface: {
      type: Boolean,
      default: false
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      layingTypes: [],
      pointTypes: []
    }
  },
  computed: {
    recId: function () {
      return this.type + 'Id'
    },
    materialsSourceReport: function () {
      const materialsSourceReport = this.resultValue.materialsSourceReport
      if (!materialsSourceReport) {
        this.$q.notify({
          type: 'negative',
          message: `Ошибка инициализации работы «${this.workType.name}»`,
          progress: true,
          timeout: 8000
        })
      }
      return materialsSourceReport
    },
    otherDeparturesResultValues: function () {
      if (this.resultValue.value) {
        const currentReportKey = this.materialsSourceReport.key
        const values = Object.fromEntries(Object.entries(this.resultValue.value).filter(entry => entry[0] !== currentReportKey))
        if (Object.keys(values).length) {
          return values
        }
      }
      return null
    }
  },
  created: function () {
    this.getLayingTypes()
    this.getPointTypes()
  },
  methods: {
    onAddSegments: function () {
      this.resultValue.value[this.materialsSourceReport.key].push([])
    },
    onDeleteSegments: function (index) {
      if (index !== -1) {
        const segments = JSON.parse(JSON.stringify(this.resultValue.value[this.materialsSourceReport.key][index]))
        segments.forEach(segment => {
          if (segment[this.recId]) {
            EventBus.$emit(this.type + '-segment', { segment: segment, operation: { type: 'delete' }, reportKey: this.materialsSourceReport.key })
          }
        })

        this.resultValue.value[this.materialsSourceReport.key].splice(index, 1)
      }
    },
    getLayingTypes: function () {
      this.loading = true
      this.layingTypes = []
      axiosGet({
        url: '/service/obj/search?returnFields=name,id&type=cableMountType&limit=5000',
        onSuccess: (response) => {
          this.layingTypes = response.data.result
        },
        onFailure: 'Ошибка загрузки способов прокладки',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    getPointTypes: function () {
      this.loading = true
      this.pointTypes = []
      axiosGet({
        url: '/service/obj/search?returnFields=name,id&add=needAdditionalId&type=cableTracePointType&limit=5000',
        onSuccess: (response) => {
          this.pointTypes = response.data.result
        },
        onFailure: 'Ошибка загрузки типов точек объекта',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    }
  }
}

